import React from 'react';

import { Box, HStack, Switch, VStack, makeUclComponent } from '@rbilabs/universal-components';
import { Typography, withTypography } from 'ucl/components/text/Typography';

import Link from 'components/link';
import { primitive } from 'styles/constants';

export const CommPreferenceLabel = withTypography({
  variant: 'headerThree',
  mb: '$2',
  fontSize: 'lg',
});

export const CommPreferenceDescription = withTypography({ fontSize: 'md', m: '$0', mb: '$4' });

export const ToggleContainer = HStack.withConfig(
  ({ hideBottomBorder }: { hideBottomBorder?: boolean }) => ({
    ...(!hideBottomBorder && {
      borderBottomWidth: 1,
      borderBottomColor: primitive.$blackOpacity10,
    }),
    paddingY: '$4',
    width: '100%',
    _web: {
      paddingRight: 2,
    },
    _android: {
      paddingRight: 2,
    },
  })
);

export const ToggleLabelContainer = VStack.withConfig({
  flex: 1,
});

export const ToggleLabel = withTypography({ variant: 'copyTwo', fontSize: 'md' });

export const ToggleDescription = ({
  isDisabled,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & { isDisabled?: boolean }) =>
  React.createElement(Typography, {
    ...(isDisabled ? { color: primitive.$blackOpacity50 } : {}),
    ...props,
  });

export const ToggleButton = Switch.withConfig({
  offTrackColor: primitive.$blackOpacity50,
  onTrackColor: primitive.$crunchyGreen,
});

export const LoadingToggleContainer = HStack.withConfig({
  marginRight: '$4',
});

export const InputContainer = Box.withConfig({
  marginBottom: '$3',
  width: '100%',
});

export const PermissionsContainer = Box.withConfig({
  marginBottom: '$3',
});

export const StyledOptInLink = makeUclComponent(Link).withConfig({
  isInline: true,
  isUnderlined: true,
});
